const localizationConfig = {
  AR: {
    messages: {
      welcome_back: "مرحباً بك مرة أخرى",
      welcome_new:
        "أهلا بيك، أنا اسمى تراكى مساعدك الشخصى من الشركة المصرية لخدمات التتبع وتكنولوجيا المعلومات",
      ask_name: "انت اسمك ايه؟",
      say_hi: "اهلا بيك يا",
      help_prompt: "اختار اقدر اساعدك ازاي؟",
      services_prompt: "توفر الشركة مجموعة من الخدمات. رجاءً اختر خدمة",

      required_documents: "المستندات المطلوبة لتفعيل خدمة التتبع",
      choose_category: "من فضلك اختر الفئة",

      common_questions_prompt: `اكتشف إجابات للأسئلة الشائعة وإرشادات للتعامل مع مختلف الحالات، بما في ذلك متطلبات المستندات وإجراءات الخدمة واستفسارات العملاء.`,

      call_support: "رجاءً اتصل على 19382",
      unknown_input:
        "عذرًا، لا أفهم رسالتك 😢! رجاءً أختار من القائمة التالية:",
      need_more_help: "لسه محتاج لمساعده؟",
    },
    options: {
      help: ["عرض خدماتنا", "إجراءات ومستندات التعاقد", "الأسئلة الشائعة"],
      services: [
        {
          key: "tracking",
          text: "خدمـات التتبـع",
          link: "/tracking-services-det",
        },
        {
          key: "integration",
          text: "خدمـات التكامل",
          link: "/system-integration-services-det",
        },
        {
          key: "network",
          text: "خدمـات شبكـات الحاســب",
          link: "/network-services-det",
        },
      ],

      docs_categories: [
        {
          key: "new_contract_broker",
          text: "تعاقد جديد جمرك / دفع رباعى – مستخلص",
          details: `
- صورة بطاقة الرقم القومي لمالك السيارة و اصل التوكيل الرسمي العام بالتعامل مع الشركة المصرية لخدمات التتبع وشركات المحمول + صورة بطاقة الموكل و الموكل عنه.
- صورة بوليصة او دفتر التريبتيكت او صورة رخصة السيارة أو تسلسل المبيعات و صورة المعاينه و الافراج الجمركي (في حالة الشراء من معرض أو وكيل).
- صورة من عقد شريحة التتبع بإسم المالك للسيارة على نظام (عربيتي 135 من فودافون) او( متابع 135 من أورانج) أو(My Car 135 من اتصالات).
    `,
        },
        {
          key: "new_contract_personal",
          text: "تعاقد جديد جمرك / دفع رباعى – شخصى",
          details: `
- صورة بطاقة الرقم القومي لمالك السيارة.
- صورة بوليصة او دفتر التريبتيكت او صورة رخصة السيارة أو تسلسل المبيعات و صورة المعاينه و الافراج الجمركي (في حالة الشراء من معرض أو وكيل).
- صورة من عقد شريحة التتبع بإسم المالك للسيارة على نظام (عربيتي 135 من فودافون) او( متابع 135 من أورانج) أو(My Car 135 من اتصالات).
    `,
        },
        {
          key: "new_contract_company",
          text: "تعاقد جديد جمرك / دفع رباعى – شركات",
          details: `
- صورة بوليصة او دفتر التريبتيكت او صورة رخصة السيارة أو تسلسل المبيعات + الافراج الجمركي (في حالة الشراء من معرض أو وكيل).
- صورة السجل التجاري والبطاقة الضريبية – خطاب تفويض +  صورة بطاقة المفوض.
- صورة من عقد شريحة التتبع بإسم الشركة للسيارات على نظام (عربيتي 135 من فودافون) او( متابع 135 من أورانج) أو (My Car 135 من اتصالات).
    `,
        },
        {
          key: "individual_contracts",
          text: "تعاقد افراد",
          details: `
- صورة بطاقة الرقم القومي لمالك السيارة – في حالة عدم وجود مالك السيارة ( اصل التوكيل الرسمي العام بالتعامل مع الشركة المصرية لخدمات التتبع وشركات المحمول + صورة بطاقة الموكل و الموكل عنه).
- صورة رخصة السيارة.
- صورة من عقد شريحة التتبع بإسم المالك للسيارة على نظام (عربيتي 135 من فودافون) او ( متابع 135 من أورانج) أو (My Car 135 من اتصالات).
    `,
        },
        {
          key: "company_contracts",
          text: "تعاقد شركات",
          details: `
- صور رخص السيارات باسم الشركة.
- صورة السجل التجاري والبطاقة الضريبية – خطاب تفويض +  صورة بطاقة المفوض.
- صورة من عقد شريحة التتبع بإسم الشركة للسيارات على نظام (عربيتي 135 من فودافون) او ( متابع 135 من أورانج) أو (My Car 135 من اتصالات).
    `,
        },
        {
          key: "ownership_transfer_individuals",
          text: "نقل ملكية جهاز التتبع للأفراد",
          details: `
- أصل خطاب تنازل الجهاز و تنازل الشريحة / اقرار الشريحة المستلمة من الموزع او المعرض او الوكيل.
- صورة بطاقة الرقم القومي لمالك السيارة أو صورة من التوكيل الرسمي العام بالتعامل مع الشركة المصرية لخدمات التتبع وشركات المحمول + صورة بطاقة الموكل و الموكل عنه.
- تسلسل المبيعات للسيارة.
- صورة من الإفراج الجمركي الخاص بالسيارة.
- صورة من عقد شريحة التتبع بإسم المالك للسيارة على نظام (عربيتي 135 من فودافون) او( متابع 135 من أورانج) أو(My Car 135 من اتصالات).
- اصل استمارة التركيب في حالة تركيب الجهاز من قبل.
    `,
        },
        {
          key: "ownership_transfer_companies",
          text: "نقل ملكية جهاز التتبع للشركات",
          details: `
- أصل خطاب تنازل الجهاز و تنازل الشريحة / اقرار الشريحة المستلمة من الموزع او المعرض او الوكيل.
- صورة السجل التجاري والبطاقة الضريبية – خطاب تفويض +  صورة بطاقة المفوض.
- صورة من الإفراج الجمركي الخاص بالسيارة.
- صورة من عقد شريحة التتبع بإسم المالك للسيارة على نظام (عربيتي 135 من فودافون) او( متابع 135 من أورانج) أو(My Car 135 من اتصالات).
- اصل استمارة التركيب في حالة تركيب الجهاز من قبل.
    `,
        },
        {
          key: "tourism_contracts",
          text: "تعاقد شركات السياحة",
          details: `
- التقديم فى غرفة السياحة لتركيب اجهزة تتبع في السيارات الخاصة بالشركة وتحديد ميعاد للتعاقد والتركيب.
- صورة السجل التجاري والبطاقة الضريبية – خطاب تفويض +  صورة بطاقة المفوض.
- صورة من عقد شريحة التتبع بإسم الشركة للسيارات على نظام (عربيتي 135 من فودافون) او ( متابع 135 من أورانج) أو (My Car 135 من اتصالات).
- صور رخص السيارات / صور مبايعات السيارات.
    `,
        },
        {
          key: "petroleum_contractor_contracts",
          text: "تعاقد مقاولين نقل مواد بترولية",
          details: `
- التقديم فى شركة البترول التابع لها لتركيب اجهزة تتبع في السيارة مع تقديم خطاب من شركة البترول للموافقه على تركيب جهاز تتبع بالسيارات المذكورة.
- صورة السجل التجاري والبطاقة الضريبية الخاص بشركة البترول التابع لها.
- صورة من عقد شريحة التتبع بإسم مالك السيارة على نظام (عربيتي 135 من فودافون) او ( متابع 135 من أورانج) أو (My Car 135 من اتصالات).
- صور رخص السيارات / صور مبايعات السيارات.
          `,
        },
      ],

      common_questions: [
        {
          key: "vehicleSale_person_to_person_or_company",
          text: "بيع سيارة بالجهاز من شخص الى شخص أو شركة",
          details: `
الأوراق المطلوبة:
تنازل عن الجهاز من المالك القديم بمقر الشركة المصرية لخدمات التتبع.
تنازل عن الشريحة من شركة المحمول أو شراء شريحة جديدة بإسم المالك الجديد مع وجود مخالصة مالية عن الشريحة القديمة.
`,
        },
        {
          key: "vehicleSale_license_not_in_contractor_name",
          text: "رخصة السيارة ليست بإسم المتعاقد",
          details: `
إذا كانت رخصة السيارة ليست باسم المتعاقد في حالة الأفراد:
يتم عمل توكيل بالشهر العقاري من صاحب السيارة يفيد بتركيب جهاز تتبع بالسيارة.
إذا كانت رخصة السيارة ليست باسم المتعاقد في حالة الشركات:
يتم عمل تفويض من صاحب السيارة يفيد بتركيب جهاز تتبع بالسيارة.
          `,
        },
        {
          key: "vehicleSale_non_egyptian_nationality",
          text: "عميل لا يحمل الجنسية المصرية",
          details: `
إذا كان العميل لا يحمل الجنسية المصرية:
يتم طلب صورة جواز السفر بدلاً من صورة البطاقة الشخصية.
          `,
        },
        {
          key: "government_organizations_tracking_device_contract",
          text: "التعاقد مع الهيئات والمؤسسات الحكومية",
          details: `
في حالة رغبة الهيئات والمؤسسات الحكومية في التعاقد على تركيب أجهزة تتبع:
يتم طلب خطاب وزاري بمزاولة المهنة بدلاً من السجل التجاري والبطاقة الضريبية.
          `,
        },
        {
          key: "medical_clinics_tracking_device_contract",
          text: "التعاقد مع أصحاب المهن الحرة (بدون سجل تجاري)",
          details: `
في حالة رغبة الهيئات التي لا تملك سجل تجاري في التعاقد على أجهزة تتبع:
يتم طلب ورقة مزاولة مهنة بدلاً من السجل التجاري.
          `,
        },
        {
          key: "change_mobile_network",
          text: "تغيير شركة المحمول",
          details: `
في حالة رغبة العميل في تغيير شركة المحمول:
يتم إرسال طلب الى قسم التفعيل والتشغيل على fms.activation@etit-eg.com
مخالصة مالية من شركة المحمول السابقة يفيد بعدم وجود اي مديونيات على العميل
عقد الشرائح مع شركة المحمول الجديدة
ارسال استمارات التركيب بتغيير رقم الشريحة
دفع الرسوم المستحقة لتغيير الشرائح بمقر الشركة المصرية لخدمات التتبع وتكنولوجيا المعلومات
          `,
        },
        {
          key: "new_sim_same_number",
          text: "تركيب شريحة جديدة بنفس الرقم",
          details: `
في حالة رغبة العميل في تركيب شريحة جديدة بنفس الرقم:
الأوراق المطلوبة هي (استمارة تركيب جديدة من شركة ETIT).
          `,
        },
        {
          key: "new_sim_different_number",
          text: "تركيب شريحة جديدة برقم مختلف",
          details: `
في حالة رغبة العميل في تركيب شريحة جديدة برقم مختلف على نفس شركة المحمول:
الأوراق المطلوبة هي (عقد الشريحة الجديد - استمارة تركيب جديدة من شركة ETIT).
          `,
        },
      ],

      go_back: [
        {
          key: "help_go_back",
          path: "offering_help",
          text: "الرجوع للقائمة الرئيسية",
        },
        {
          key: "category_go_back",
          path: "docs_category_options",
          text: "رجوع للمستندات",
        },
        {
          key: "common_q_go_back",
          path: "common_questions_options",
          text: "رجوع للأسئلة الشائعة",
        },
      ],
    },
  },

  EN: {
    messages: {
      welcome_back: "Welcome back",
      welcome_new:
        "Hello! My name is Tracky, your personal assistant from ETIT.",
      ask_name: "What is your name?",
      say_hi: "Nice to meet you",
      help_prompt: "How can I assist you?",
      services_prompt: "We offer a wide range of services. Please choose one.",

      required_documents: "Required documents for activating tracking service",
      choose_category: "Please choose a category :",

      common_questions_prompt: `Find answers to frequently asked questions and guidelines for various scenarios, including documentation requirements, service processes, and customer inquiries.`,

      call_support: "Please call 19382 for support.",
      unknown_input:
        "Sorry, I don’t understand your message 😢! Please select from the options below:",
      need_more_help: "Do you still need assistance?",
    },
    options: {
      help: [
        "View our services",
        "Contracting procedures and documents",
        "Common Questions",
      ],
      services: [
        {
          key: "tracking",
          text: "Tracking Services",
          link: "/tracking-services-det",
        },
        {
          key: "integration",
          text: "System Integration Services",
          link: "/system-integration-services-det",
        },
        {
          key: "network",
          text: "Network Services",
          link: "/network-services-det",
        },
      ],

      docs_categories: [
        {
          key: "new_contract_broker",
          text: "New Contract Customs / 4WD – Broker",
          details: `
- A copy of the national ID of the car owner and the original general power of attorney to deal with the Egyptian Company for Tracking Services and mobile companies + a copy of the attorney's ID and the one they represent.
- A copy of the bill of lading, trip ticket book, or vehicle license, or sales sequence, and a copy of the inspection and customs release (if purchased from a showroom or agent).
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
    `,
        },
        {
          key: "new_contract_personal",
          text: "New Contract Customs / 4WD – Personal",
          details: `
- A copy of the national ID of the car owner.
- A copy of the bill of lading, trip ticket book, or vehicle license, or sales sequence, and a copy of the inspection and customs release (if purchased from a showroom or agent).
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
    `,
        },
        {
          key: "new_contract_company",
          text: "New Contract Customs / 4WD – Company",
          details: `
- A copy of the bill of lading, trip ticket book, or vehicle license, or sales sequence + customs release (if purchased from a showroom or agent).
- A copy of the commercial register and tax card – authorization letter + a copy of the authorized person's ID.
- A copy of the tracking chip contract in the name of the company for the vehicles on the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
    `,
        },
        {
          key: "individual_contracts",
          text: "Individual Contracts",
          details: `
- A copy of the national ID of the car owner – if the car owner is unavailable (original general power of attorney to deal with the Egyptian Company for Tracking Services and mobile companies + a copy of the attorney's ID and the one they represent).
- A copy of the vehicle license.
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
    `,
        },
        {
          key: "company_contracts",
          text: "Company Contracts",
          details: `
- Copies of the vehicle licenses in the company name.
- A copy of the commercial register and tax card – authorization letter + a copy of the authorized person's ID.
- A copy of the tracking chip contract in the name of the company for the vehicles on the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
    `,
        },
        {
          key: "ownership_transfer_individuals",
          text: "Transfer of Ownership of Tracking Device to Individuals",
          details: `
- Original device transfer letter and chip transfer / declaration of chip received from the distributor, showroom, or agent.
- A copy of the national ID of the car owner or a copy of the general power of attorney to deal with the Egyptian Company for Tracking Services and mobile companies + a copy of the attorney's ID and the one they represent.
- Sales sequence of the vehicle.
- A copy of the vehicle's customs release.
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
- The original installation form if the device was previously installed.
    `,
        },
        {
          key: "ownership_transfer_companies",
          text: "Transfer of Ownership of Tracking Device to Companies",
          details: `
- Original device transfer letter and chip transfer / declaration of chip received from the distributor, showroom, or agent.
- A copy of the commercial register and tax card – authorization letter + a copy of the authorized person's ID.
- A copy of the vehicle's customs release.
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
- The original installation form if the device was previously installed.
    `,
        },
        {
          key: "tourism_contracts",
          text: "Tourism Companies Contracts",
          details: `
- Apply at the Tourism Chamber for installing tracking devices in the company's vehicles and schedule a time for contracting and installation.
- A copy of the commercial register and tax card – authorization letter + a copy of the authorized person's ID.
- A copy of the tracking chip contract in the name of the company for the vehicles on the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
- Copies of the vehicle licenses / copies of vehicle sales.
    `,
        },
        {
          key: "petroleum_contractor_contracts",
          text: "Petroleum Transport Contractors Contracts",
          details: `
- Apply at the affiliated petroleum company to install tracking devices in the vehicles with a letter from the petroleum company approving the installation of the device in the mentioned vehicles.
- A copy of the commercial register and tax card of the affiliated petroleum company.
- A copy of the tracking chip contract in the name of the car owner for the system (My Car 135 from Vodafone) or (Mutaba'a 135 from Orange) or (My Car 135 from Etisalat).
- Copies of the vehicle licenses / copies of vehicle sales.
        `,
        },
      ],
      common_questions: [
        {
          key: "vehicleSale_person_to_person_or_company",
          text: "Selling a vehicle with the device from an individual to another individual or a company",
          details: `
      Required Documents:
      - A waiver of the device by the previous owner at the headquarters of the Egyptian Tracking Services Company.
      - A waiver of the SIM card from the mobile company or purchase of a new SIM card under the name of the new owner, along with financial clearance for the old SIM card.
          `,
        },
        {
          key: "vehicleSale_license_not_in_contractor_name",
          text: "Vehicle license not in the name of the contractor",
          details: `
      If the vehicle license is not in the name of the contractor for individuals:
      - A power of attorney must be issued at the notary public from the vehicle owner authorizing the installation of a tracking device in the vehicle.
      If the vehicle license is not in the name of the contractor for companies:
      - A delegation must be issued from the vehicle owner authorizing the installation of a tracking device in the vehicle.
          `,
        },
        {
          key: "vehicleSale_non_egyptian_nationality",
          text: "Customer does not hold Egyptian nationality",
          details: `
      If the customer does not hold Egyptian nationality:
      - A copy of the passport is required instead of the national ID.
          `,
        },
        {
          key: "government_organizations_tracking_device_contract",
          text: "Contracting with government organizations and institutions",
          details: `
      For government organizations and institutions wishing to contract for the installation of tracking devices:
      - A ministerial letter of profession practice is required instead of the commercial registry and tax card.
          `,
        },
        {
          key: "medical_clinics_tracking_device_contract",
          text: "Contracting with freelancers (without a commercial registry)",
          details: `
      For entities without a commercial registry wishing to contract for tracking devices:
      - A profession practice document is required instead of the commercial registry.
          `,
        },
        {
          key: "change_mobile_network",
          text: "Changing the mobile network provider",
          details: `
      For customers wishing to change the mobile network provider:
      - A request must be sent to the Activation and Operation Department at fms.activation@etit-eg.com.
      - Financial clearance from the previous mobile provider indicating no outstanding debts.
      - A SIM card contract with the new mobile provider.
      - Submission of installation forms reflecting the SIM card number change.
      - Payment of applicable fees for SIM card changes at the headquarters of the Egyptian Tracking Services and IT Company.
          `,
        },
        {
          key: "new_sim_same_number",
          text: "Installing a new SIM card with the same number",
          details: `
      For customers wishing to install a new SIM card with the same number:
      - Required documents include (a new installation form from ETIT).
          `,
        },
        {
          key: "new_sim_different_number",
          text: "Installing a new SIM card with a different number",
          details: `
      For customers wishing to install a new SIM card with a different number on the same mobile provider:
      - Required documents include (the new SIM card contract - a new installation form from ETIT).
          `,
        },
      ],

      go_back: [
        {
          key: "help_go_back",
          path: "offering_help",
          text: "Main Menu",
        },
        {
          key: "category_go_back",
          path: "docs_category_options",
          text: "Back To Documents",
        },
        {
          key: "common_q_go_back",
          path: "common_questions_options",
          text: "Back To Common Questions",
        },
      ],
    },
  },
};

export default localizationConfig;
